/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Why_Familiar_DescInputs */

const en_wc_why_familiar_desc = /** @type {(inputs: Wc_Why_Familiar_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Word's ribbon tabs, groups and shortcuts: Enter continues a list, Tab demotes it, F4 repeats, F7 checks spelling.`)
};

/**
* | output |
* | --- |
* | "Word's ribbon tabs, groups and shortcuts: Enter continues a list, Tab demotes it, F4 repeats, F7 checks spelling." |
*
* @param {Wc_Why_Familiar_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_why_familiar_desc = /** @type {((inputs?: Wc_Why_Familiar_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Why_Familiar_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_why_familiar_desc(inputs)
});
export { wc_why_familiar_desc as "wc.why.familiar.desc" }